$(document).ready(function() {
	if ($('.jq_fund_excenter').length) {
		var windowWidth;

		fundExcenter();

		$(window).on('resize', fundExcenter);
	}

	function fundExcenter() {
		windowWidth = window.innerWidth;

		var $excenters = $('.jq_fund_excenter');

		if (windowWidth < 768) {
			$excenters.removeAttr('style');

			return;
		}

		$excenters.width(1);

		$excenters.each(function() {
			var $excenter = $(this);

			if ($excenter.hasClass('jq_fund_excenter_even')) {
				var width = $excenter.position().left;
			} else {
				var width = windowWidth - $excenter.position().left;
			}

			$excenter.width(width + 10);
		});
	}
});
